import React from 'react';
import styled from 'styled-components';
import Badge from '@mui/material/Badge';

export interface INumericalCircleProps {
  backgroundColor: string;
  color: string;
  value: number;
  size: number;
  fontSize: number;
}

interface ICircleProps {
  backgroundcolor: string;
  fontcolor: string;
  fontSize: number;
  size: number;
}

const Circle = styled(Badge) <ICircleProps>`
  &.MuiBadge-root {
    width: ${(props) => props.size}px;
  }

  .MuiBadge-badge {
    background-color: ${(props) => props.backgroundcolor};
    color: ${(props) => props.fontcolor};
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    margin-right: ${(props) => props.size / 2}px;
    border-radius: ${(props) => props.size / 2}px;
    font-size: ${(props) => props.fontSize}px;
  }
`;

const NumericalCircle: React.FC<INumericalCircleProps> = ({
  backgroundColor, color, value, size, fontSize,
}) => (
  <Circle badgeContent={value.toString()} backgroundcolor={backgroundColor} fontcolor={color} size={size} fontSize={fontSize} />
);

export default NumericalCircle;
